/**
 * ShirobonAI Custom Icon
 * しろぼんAIのカスタムアイコン（ロボット顔）
 */

import { useId } from "react";

interface ShirobonAIIconProps {
  size?: number;
  className?: string;
  style?: React.CSSProperties;
}

export function ShirobonAIIcon({ size = 32, className, style }: ShirobonAIIconProps) {
  // ユニークなIDを生成して競合を防ぐ
  const uniqueId = useId();
  const gradientId = `shirobonai-gradient-${uniqueId}`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ 
        display: 'block',
        visibility: 'visible',
        opacity: 1,
        ...style 
      }}
      aria-hidden="true"
    >
      {/* 背景グラデーション */}
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="512" y2="512" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#29aadd" />
          <stop offset="100%" stopColor="#076e9a" />
        </linearGradient>
      </defs>

      {/* ベース形状 (角丸正方形) */}
      <rect x="32" y="32" width="448" height="448" rx="112" fill={`url(#${gradientId})`} />

      {/* ロボットの顔 */}
      <g transform="translate(106, 136) scale(0.6)">
        {/* アンテナ */}
        <line x1="250" y1="20" x2="250" y2="80" stroke="#ffffff" strokeWidth="24" strokeLinecap="round" />
        <circle cx="250" cy="20" r="20" fill="#ffffff" />

        {/* 顔の輪郭 */}
        <rect x="50" y="80" width="400" height="320" rx="60" fill="#ffffff" />
        
        {/* 耳/ヘッドフォン部分 */}
        <path d="M50 180 H20 A20 20 0 0 0 0 200 V 280 A20 20 0 0 0 20 300 H50 V 180 Z" fill="#E1F5FE" />
        <path d="M450 180 H480 A20 20 0 0 1 500 200 V 280 A20 20 0 0 1 480 300 H450 V 180 Z" fill="#E1F5FE" />

        {/* 目 */}
        <circle cx="160" cy="220" r="30" fill="#076e9a" />
        <circle cx="340" cy="220" r="30" fill="#076e9a" />

        {/* 口 (スマイル) */}
        <path d="M180 300 Q250 350 320 300" stroke="#076e9a" strokeWidth="24" strokeLinecap="round" fill="none" />

        {/* 頬 */}
        <circle cx="130" cy="260" r="15" fill="#FFA5A5" fillOpacity="0.6" />
        <circle cx="370" cy="260" r="15" fill="#FFA5A5" fillOpacity="0.6" />
      </g>
    </svg>
  );
}

